/// <reference path="LayoutControls.js" />
window.Helpers = function () {
    function fixDotnetCasing(obj, excludeProp) {
        for (var prop in obj)
            if (obj.hasOwnProperty(prop) && (!excludeProp || excludeProp.indexOf(prop) < 0)) {

                var lcProp = prop.replace(/^[A-Z]/, function (c, i) { return c.toLowerCase(); });
                lcProp = lcProp.replace(/[A-Z]{2,}/, function (c, i) {
                    return c.charAt(0).toUpperCase() + c.substr(1).toLowerCase();
                });
                obj[lcProp] = obj[prop];
                if (typeof obj[prop] == 'object')
                    fixDotnetCasing(obj[prop]);

                //prop could also be an array index, dont modify
                if (lcProp !== prop && isNaN(parseInt(prop)))
                    delete obj[prop];
            }
    }

    function objPropertiesToUpperCase(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {

                var lcProp = prop.replace(/^[a-z]/, function (c, i) { return c.toUpperCase(); });
                obj[lcProp] = obj[prop];
                if (typeof obj[prop] == 'object')
                    objPropertiesToUpperCase(obj[prop]);

                //prop could also be an array index, dont modify
                if (lcProp !== prop && isNaN(parseInt(prop)))
                    delete obj[prop];
            }
        }
    }

    function padString(str, len) {
        var res = '' + str;
        len = len - res.length;
        if (len <= 0) return res;
        while (len--)
            res = '0' + res;
        return res;
	}

	function getRangesFromArray(array) {
		// sort first
		array.sort(function (a, b) { return a - b });

		var ranges = [], rstart, rend;
		for (var i = 0; i < array.length; i++) {
			rstart = array[i];
			rend = rstart;
			while (array[i + 1] - array[i] == 1) {
				rend = array[i + 1]; // increment the index if the numbers sequential
				i++;
			}
			ranges.push(rstart == rend ? rstart + '' : rstart + '-' + rend);
		}
		return ranges;
	}

	function getArrayFromRanges(ranges) {
		var array = [];

		for (var i = 0; i < ranges.length; i++) {
			var rangeEnds = ranges[i].trim().split('-');

			if (rangeEnds.length > 0) {
				var rangeStart = parseInt(rangeEnds[0], 10);

				if (rangeEnds.length > 1) {
					var rangeEnd = parseInt(rangeEnds[1], 10);

					if (rangeEnd < rangeStart)
						return false;

					for (var j = rangeStart; j <= rangeEnd; j++)
						if (array.indexOf(j) < 0)
							array.push(j);
				} else if (array.indexOf(rangeStart) < 0)
					array.push(rangeStart);
			}
		}

		return array;
    }

    function hasFlag(value, flag) { return (value & flag) !== 0; }

    function decodeHtml(encodedText) {
        return new DOMParser().parseFromString(encodedText, "text/html").documentElement.textContent;
    }
    //dummy impl. of console.log so it doesn't cause errors if log statements are left in code
    window.console = window.console || { log: function () { } };


    /* performJSonCall & performJSonCallLC is deprecated, do not add any more calls to them */
    return {

        performJSonCall: function (url, data, successCallback, failCallback, synchronous) {
            var qry = window.document.URL.toString();
            if (qry.indexOf('?') > 0)
                qry = '?' + encodeURI(qry.split('?')[1]);
            else
                qry = null;

            url += qry ? qry : '';

            if (synchronous === null || synchronous === undefined) {
                synchronous = false;
            }
            $.ajax({
                type: "POST",
                url: url,
                dataType: "json",
                data: data == null ? null : JSON.stringify(data),
                async: !synchronous,
                contentType: "application/json; charset=utf-8",
                success: function (msg) {
                    if (successCallback) {
                        successCallback(msg.d);
                    }
                },
                error: function (xhr, status, err) {
                    if (Helpers.isUnloading) return;
                    var errObj = JSON.parse(xhr.responseText);
                    errObj.method = url;
                    errObj.calldata = this.data;

                    if (!/LogErr$/i.test(url))
                        Helpers.logErr(errObj);

                    if (failCallback) {
                        failCallback(errObj.Message);
                    }
                }
            });
        },
        performJSonCall2: function (method, data, successCallback, failCallback, message) {
            var qry = window.document.URL.toString();
            if (qry.indexOf('?') > 0)
                qry = '?' + encodeURI(qry.split('?')[1]);
            else
                qry = null;

            method += qry ? qry : '';

            var loadingBar = Storyboard.LayoutControls.showLoadingBar(message);
            $.ajax({
                type: "POST",
                url: (window.IsFormReport ? 'FormReport.aspx/' : 'RHViewStoryboard.aspx/') + method,
                dataType: "json",
                data: data == null ? null : JSON.stringify(data),
                contentType: "application/json; charset=utf-8",
                success: function (msg) {
                    if (message)
                        Storyboard.LayoutControls.hideLoadingBar(loadingBar);
                    if (successCallback) {
                        successCallback(msg.d);
                    }
                },
                error: function (xhr, status, err) {
                    if (Helpers.isUnloading) return;
                    var errObj = JSON.parse(xhr.responseText);
                    errObj.method = method;
                    errObj.calldata = this.data;
                    Helpers.logErr(errObj);
                    Storyboard.LayoutControls.showError(errObj.Message || 'Unknown error occured');

                    if (failCallback) {
                        failCallback(errObj.Message);
                    }
                }
            });
        },

        perfGenericJSonCall: function (url, parameters, successCallback) {
            $.ajax({
                type: 'POST',
                url: url,
                data: parameters,
                contentType: "application/json; charset=utf-8",
                dataType: 'json',
                success: function (response) {
                    successCallback(response);
                },
                error: function () {
                    alert('Error getting data.');
                }
            });
		},

		deleteExportTemplate: function (params) {

			if (arguments.length === 3 || arguments.length === 4) {
				params = {
					method: arguments[0],
					data: arguments[1],
					successCallback: arguments[2],
					message: arguments[3]
				};
			}

			//allows escaping the storyboard root with '../'
			if (params.service.substr(0, 2) != '..')
				params.service = '../Storyboard/services/' + params.service + '.aspx/';

			var loadingBar = Storyboard.LayoutControls.showLoadingBar(params.message, params.cancelCallback);
			var qry = window.document.URL.toString();
			if (qry.indexOf('?') > 0)
				qry = '?' + encodeURI(qry.split('?')[1]);
			else
				qry = null;
			params.method += qry ? qry : '';

			var formData = new FormData();
			formData.append('templateId', params.data.templateId);

			Storyboard.LayoutControls.hideLoadingBar(loadingBar);
			new DUIwindow2({
				width: 400,
				topPosition: '',
				closeButton: false,
				html: '<p>Do you really want to delete this template?</p>',
				buttons: [
					{
						text: 'No', onClick: function () {

						}
					},
					{
						text: 'Yes', focused: true, onClick: function () {
							return $.ajax({
								type: "POST",
								url: "FileHandler.ashx?deleteTemplate=true",
								processData: false,
								contentType: false,
								data: formData,
								success: function (msg) {
									Storyboard.LayoutControls.hideLoadingBar(loadingBar);

									if ($("input[name=templateChooser][value='" + params.data.templateId + "']").length > 0) {
										$("input[name=templateChooser][value='" + params.data.templateId + "']").closest('tr').remove();
									}
									if (!$("input[name=templateChooser]:checked").val()) {
										$("input[name=templateChooser][value='0']").attr("checked", true);
									}
								},
								error: function (http) {
									try {
										if (!/LogErr$/i.test(this.url))
											Helpers.logErr(http);
									} catch (e) { /* empty */ }
								}
							});
						}
					}
				]
			});
		},

		uploadExportTemplate: function (params) {

			if (arguments.length === 3 || arguments.length === 4) {
				params = {
					method: arguments[0],
					data: arguments[1],
					successCallback: arguments[2],
					message: arguments[3]
				};
			}

			//allows escaping the storyboard root with '../'
			if (params.service.substr(0, 2) != '..')
				params.service = '../Storyboard/services/' + params.service + '.aspx/';

			var loadingBar = Storyboard.LayoutControls.showLoadingBar(params.message, params.cancelCallback);
			var qry = window.document.URL.toString();
			if (qry.indexOf('?') > 0)
				qry = '?' + encodeURI(qry.split('?')[1]);
			else
				qry = null;
			params.method += qry ? qry : '';

			var formData = new FormData();
			formData.append('templateName', params.data.templateName);
			formData.append('fileData', params.data.fileData);
			formData.append('overwriteTemplate', params.data.overwriteTemplate);
			formData.append('ignoreAspectRatio', params.data.ignoreAspectRatio);

			return $.ajax({
				type: "POST",
				url: "FileHandler.ashx?uploadTemplate=true",
				processData: false,
				contentType: false,
				data: formData,
				success: function (data) {
                    Storyboard.LayoutControls.hideLoadingBar(loadingBar);
                    var json = $.parseJSON(Helpers.decodeHtml(data));

					var templateId = HTMLHelpers.htmlEncode(json.templateId);
					var templateName = HTMLHelpers.htmlEncode(json.templateName);

					if ($("input[name=templateChooser][value='" + templateId + "']").length == 0) {
						$('#customTemplateTable tr:last').after('<tr><td><label style="cursor: pointer;"><input style="margin-top: -1px;vertical-align: middle;cursor: pointer;" type="radio" name="templateChooser" value="' + templateId + '">' + templateName + '</label></td><td class="favDelete_cc"><input type="button" data-tempid="' + templateId + '" class="DUIButtonGray btnTempDownload" value="Download"><input type="button" data-tempid="' + templateId + '" class="DUIButtonGray btnTempDelete" value="Delete"></td></tr>');
					}

					$(".btnTempDelete[data-tempid=" + templateId +"]").bind("click", function () {
						Storyboard.LayoutDesigner.deleteExportTemplate($(this).data("tempid"));
					});
					$(".btnTempDownload[data-tempid=" + templateId + "]").bind("click", function () {
						var iframe = document.createElement("iframe");
						iframe.src = '/Storyboard/FileHandler.ashx?downloadTemplate=true&templateId=' + $(this).data("tempid");
						iframe.style.display = "none";
						document.body.appendChild(iframe);
					});

					$("#templateName").val("");
					$("#templateFile").val("");
					$("#templateName").css('visibility', 'hidden');
					$("#addTemplateSubmit").css('visibility', 'hidden');
					$("#addTemplateForm").toggle();
				},
				error: function (xhr, status, error) {
                    Storyboard.LayoutControls.hideLoadingBar(loadingBar);
                    var json = $.parseJSON(Helpers.decodeHtml(xhr.responseText));

					switch (json.errorCode) {
						case "Generic":
							Storyboard.LayoutControls.showError(json.errorMessage || 'Unknown error occured');
							break;
						case "TemplateNameExists":
							new DUIwindow2({
								width: 400,
								topPosition: '',
								closeButton: false,
								html: '<p>Template name already exists. Do you want to overwrite the template?</p>',
								buttons: [
									{
										text: 'No', onClick: function () {

										}
									},
									{
										text: 'Yes', focused: true, onClick: function () {
											if (Storyboard.LayoutDesigner.validateNewTemplateForm()) {
												var templateName = $("#templateName").val().trim();
												var fileData = $('#templateFile')[0].files[0];
												Storyboard.LayoutDesigner.saveExportTemplate(templateName, fileData, '1', '0');
											}
										}
									}
								]
							});
							break;
						case "BadAspectRatio":
							new DUIwindow2({
								width: 400,
								topPosition: '',
								closeButton: false,
								html: '<p>The slide size of the template is not the same as the slide size of the report [' + ($("#ddlReportDocFormat option:selected").text() || '') +
									'] which will cause layout issues in the export. Do you still want to upload the template?</p>',
								buttons: [
									{
										text: 'No', onClick: function () {

										}
									},
									{
										text: 'Yes', focused: true, onClick: function () {
											if (Storyboard.LayoutDesigner.validateNewTemplateForm()) {
												var templateName = $("#templateName").val().trim();
												var fileData = $('#templateFile')[0].files[0];
												Storyboard.LayoutDesigner.saveExportTemplate(templateName, fileData, '1', '1');
											}
										}
									}
								]
							});
							break;
					}

					try {
						if (!/LogErr$/i.test(this.url))
							// eslint-disable-next-line no-undef
							Helpers.logErr(http);
					} catch (e) { /* empty */ }
				}
			});
		},

        uploadImage: function (formData, reportID, successCallback, failCallback, message) {
            var isChartCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;
            var upload = isChartCreator ? 'storyCreatorUpload' : 'upload';
            var url = 'FileHandler.ashx?' + upload + '=true&Rpid=' + reportID;
            var loadingBar = Storyboard.LayoutControls.showLoadingBar(message || 'Uploading image...');

            return $.ajax({
                type: 'POST',
                url: url,
                processData: false,
                contentType: false,
                data: formData,
                success: function (data) {
                    Storyboard.LayoutControls.hideLoadingBar(loadingBar);

                    var renderer = document.createElement('template');
                    renderer.innerHTML = data;
                    var uploaderStatus = renderer.content.querySelector('#uploaderStatus');

                    if (uploaderStatus) {
                        var uploaderStatusText = $(uploaderStatus).text();
                        if (uploaderStatusText === 'ok') {
                            if (successCallback) successCallback(data);
                        } else {
                            Storyboard.LayoutControls.showError(uploaderStatusText || 'Unknown error occured');
                            if (failCallback) failCallback();
                        }
                    }

                    renderer.remove();
                },
                error: function (xhr, status, error) {
                    Storyboard.LayoutControls.hideLoadingBar(loadingBar);
                    if (failCallback) failCallback(xhr, status, error);
                }
            });
        },

        perfJSonCall: function (params) {
            /*
            @method             web service method, relative to RHViewStoryboard.aspx/
            @data               object with fields matching the parameters of the ws method, or undefined
            @message            any message to show in gui loading bar. can be null
            @successCallback    function to call when call is complete. single parameter is payload
            @failCallback       function to call if the call fails. should in most cases be left undefined
            @synchronous        should never be used, legacy. YOU'RE KILLING THE RAINFOREST!
            @fixCasing          if set, the result is parsed and converted to js naming conventions
            @service            used to override method path. instead of assuming RhviewStoryboard.aspx/Method, it redirects to services/@service.aspx/@method
            */

            /*  we also support the old interface with method, data, successCallback and message
            passed as individual parameters */

            if (arguments.length === 3 || arguments.length === 4) {
                params = {
                    method: arguments[0],
                    data: arguments[1],
                    successCallback: arguments[2],
                    message: arguments[3]
                };
            }

            if (params.forceMyStoriesUrl) {
                params.service = 'MyStories.aspx/';
            }
            else if (!params.service) {
                params.service = window.IsMyStories ? 'MyStories.aspx/' : (window.IsFormReport ? 'FormReport.aspx/' : 'RHViewStoryboard.aspx/');
            }
            else {
                //allows escaping the storyboard root with '../'
                if (params.service.substr(0, 2) != '..')
                    params.service = '../Storyboard/services/' + params.service + '.aspx/';
            }

            if (params.message && (IsStoryboard || IsFormReport || IsMyStories))
                var loadingBar = Storyboard.LayoutControls.showLoadingBar(params.message, params.cancelCallback);
            var qry = window.document.URL.toString();
            if (qry.indexOf('?') > 0)
                qry = '?' + encodeURI(qry.split('?')[1]);
            else
                qry = null;

            params.method += qry ? qry : '';

            var url = params.service + params.method;
            // having "??" in data will promote request to jsonp, replace it with html code
            var data = (typeof params.data === 'undefined') ? null : JSON.stringify(params.data).replace(/\?\?/g, "&#63;&#63;");
             
            if (clientCache.hasData({ url, params: data })) {
                var cacheData = clientCache.getData({ url, params: data });
                if (cacheData) {
                    const deferred = $.Deferred();
                    deferred.then(function(d) {
                        if (params.message && (IsStoryboard || IsFormReport || IsMyStories)) {
                            Storyboard.LayoutControls.hideLoadingBar(loadingBar);
                        }
    
                        !!params.successCallback && params.successCallback(d);
                    });
                    deferred.resolve(cacheData);
                    return deferred.promise();
                }
            }

            return $.ajax({
                type: "POST",
                url: params.service + params.method,
                dataType: "json",
                async: !params.synchronous,
                data: data,
                contentType: "application/json; charset=utf-8",
                success: function (msg) {
                    if (params.fixCasing)
                        Helpers.fixDotnetCasing(msg.d);
                    if (params.message && (IsStoryboard || IsFormReport || IsMyStories)) {
                        Storyboard.LayoutControls.hideLoadingBar(loadingBar);
                    }

                    !!params.successCallback && params.successCallback(msg.d);

                    if (params.keepUnusedDataFor) {
                        clientCache.setData({ url, params: data, data: msg.d, keepUnusedDataFor: params.keepUnusedDataFor });
                    }
                },
                error: function(xhr, status, err) {
                    if (Helpers.isUnloading) return;
                    if (params.message && (IsStoryboard || IsFormReport || IsMyStories)) {
                        Storyboard.LayoutControls.hideLoadingBar(loadingBar);
                    }
                    var errObj = {};
                    try {
                        errObj = JSON.parse(xhr.responseText) || {};
                        errObj.method = params.method;
                        errObj.calldata = this.data;
                        if (!/LogErr$/i.test(this.url))
                            Helpers.logErr(errObj);

                        if ((IsStoryboard || IsFormReport || IsMyStories) && !(errObj.ExceptionType && errObj.ExceptionType.toLowerCase().indexOf("silentexception") > -1))
                            Storyboard.LayoutControls.showError(errObj.Message || 'Unknown error occured');

                    } catch (e) { /* empty */ }

                    !!params.failCallback && params.failCallback(errObj.Message);
                }
            });
        },
        getURLParameter: function (paramName) {
            var searchString = window.location.search.substring(1),
                i, val, params = searchString.split("&");

            for (i = 0; i < params.length; i++) {
                val = params[i].split("=");
                if (val[0].toLowerCase() == paramName.toLowerCase()) {
                    return unescape(val[1]);
                }
            }
            return null;
        },
        logErr: function (errObj) {
            var errInfo = [];
            for (var prop in errObj)
                if(errObj.hasOwnProperty(prop)) {

                    if (prop)
                        errInfo.push(prop + ': ' + errObj[prop]);
                }
            Helpers.performJSonCall((window.IsFormReport ? 'FormReport.aspx/' : 'RHViewStoryboard.aspx/') + 'LogErr', { err: errInfo.join(', ') });
        },
        sortZIndex: function (a, b) {
            if (a.zIndex < b.zIndex)
                return -1;
            if (a.zIndex > b.zIndex)
                return 1;
            return 0;
        },
        generateGuid: function () {
            /* shamelessly copied from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523 */
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        setupNumericTextbox: function (textbox, options) {
            var defaultOptions = {
                allowDecimals: true,
                clearInput: false,
                minValue: undefined,
                maxValue: undefined,
            };

            options = $.extend(defaultOptions, options);

            if (options.clearInput)
                $(textbox).val('');

            $(textbox).unbind('keypress').bind('keypress', function (event) {
                // Allow: del, backspace and arrow keys. Note keypress event code for backspace is 8 and 0 for delete and arrow key
                if (event.which === 8 || event.which === 0)
                    return;
                // dash, dot, but only if decimals are allowed
                if (options.allowDecimals && (event.which === 45 || event.which === 46)) {
                    return;
                }
                    //Ensure that it is a number and stop the keypress
                else if (event.which > 47 && event.which < 58) {
					return;
				}
					// allow extra keys defined in options
				else if (options.extraKeys && options.extraKeys.indexOf(event.which) > -1) {
					return;
				} else {
                    event.preventDefault();
                }
            });

            var setupValueBoundaries = function (tb) {
                if (options.minValue == null && options.maxValue == null)
                    return;

                var value = parseFloat($(tb).val() || 0, 10);

                if (options.minValue != null && (value < options.minValue))
                    value = options.minValue;
                else if (options.maxValue != null && (value > options.maxValue))
                    value = options.maxValue;

                $(tb).val(value);
            }

            setupValueBoundaries(textbox);

            $(textbox).unbind('blur');
            if (options.minValue != null || options.maxValue != null) {
                $(textbox).bind('blur', function (event) { setupValueBoundaries(this); });
            }
        },
        setupIntegerInput: function (textbox, maxNumOfChars, onlySignedIntegers) {
            $(textbox).keypress(function (event) {
                if (!onlySignedIntegers && event.which === 45)
                    return;

                if (event.which === 8 || event.which === 0)
                    return;

                else if (event.which > 47 && event.which < 58) {
                    var selection = Helpers.getSelectionText(this);
                    if (maxNumOfChars && this.value.length >= maxNumOfChars && selection.length === 0)
                        event.preventDefault();
                    else
                        return;
                } else {
                    event.preventDefault();
                }
            });
        },
        getSelectionText: function(el) {
            if (window.getSelection) {
                try {
                    return el.value.substring(el.selectionStart, el.selectionEnd);
                } catch (e) {
                    return '';
                }
            }
            // For IE
            if (document.selection && document.selection.type != "Control") {
                return document.selection.createRange().text;
            }
        },
        getLayoutElementSlideIndex: function (layoutElement) {
            return Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement).slideIndex;
        },
        //Copied this function from http://flav36rs.com/2009/02/27/simple-jquery-string-padding-function/
        pad: function (i, l, s) {
            var o = i.toString();
            if (!s) { s = '0'; }
            while (o.length < l) {
                o = s + o;
            }
            return o;
        },
        fixDotnetCasing: fixDotnetCasing,
		objPropertiesToUpperCase: objPropertiesToUpperCase,
		getRangesFromArray: getRangesFromArray,
        getArrayFromRanges: getArrayFromRanges,
        decodeHtml: decodeHtml,
        hasFlag: hasFlag,
        isPreview: (function () {
            var isPreview;
            return function() {
                if (typeof isPreview !== 'boolean') {
                    isPreview = document.body.contains(document.getElementById('ADMIN_RH_PREVIEWMODE_PANEL'));
                }
                return isPreview;
            }
        })(),
        getReportID: function () {
            var reportID = this.getURLParameter('RpId');
            if (reportID != null)
                reportID = parseInt(reportID, 10);
            return reportID;
        },
        getReportName: function () {
            var currentURL = window.document.URL.toString();
            currentURL = currentURL.slice(currentURL.indexOf("RpId"));
            return $('#nav').find('a[href$="' + currentURL + '"]').text();
        },
        getPageNoFromUrl: function () {
            var pageNo = this.getURLParameter('slide');
            if (pageNo != null)
                pageNo = parseInt(pageNo, 10);
            return pageNo;
        },
        createCookie: function (name, value) {
            document.cookie = name + "=" + value + "; path=/";
        },
        readCookie: function (name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },
        eraseCookie: function (name) {
            this.createCookie(name, "");
        },
        reportLoadingProgress: function (total, tasksLeft) {
            /* we count active requests as half-complete, otherwise a batch with 4 requests
			would be reported as 100% from the start since they are popped of the queues */
            var progress = Math.round(100 - (tasksLeft / total) * 100);

            /* make sure progress is between 0 and 100. rather lie than look like a fool */
            progress = Math.max(0, progress);
            progress = Math.min(100, progress);

            $("#reportprogressBar").width(Math.floor(progress * 2, 10));
            if (!Storyboard.LayoutDesigner.slideShowMode) {
                $('.DUI-ST-NAVIGATOR').toggle(tasksLeft != 0);
                $("#reportProgress").toggle(tasksLeft != 0);
            }

            var layoutElements = Storyboard.LayoutDesigner.getLayoutElements();
            var visibleElements = $.grep(layoutElements, function (v, i) {
                if (Helpers.getLayoutElementSlideIndex(v) == Storyboard.LayoutDesigner.getCurrentPageNo()) {
                    //skip images, text and icon shapes
                    var elementItem = layoutElements[i].layoutElementItems[0];
                    return (elementItem && elementItem.itemType != 5 && elementItem.itemType != 4 && elementItem.itemType != 16);
                } else {
                    return false;
                }
            });

            var slideTasksDone = 0;
            for (var i in visibleElements) {
                if (visibleElements.hasOwnProperty(i)) {
                    if (visibleElements[i].hasOwnProperty("GUILoaded")) {
                        slideTasksDone++;
                    } else {
                        if (Storyboard.LayoutDesigner.getLayoutElementType(visibleElements[i]) == 8) {
                            //Text Elements
                            slideTasksDone++;
                        } else {
                            //just not ready yet...
                        }
                    }
                }
            }

            var slideProgress = Math.round((slideTasksDone / visibleElements.length) * 100);
            slideProgress = Math.max(0, slideProgress);
            slideProgress = Math.min(100, slideProgress);
            $("#progressBar").width(slideProgress * 2);
            $("#contentProgress").toggle(Storyboard.LayoutDesigner.slideShowMode && slideTasksDone != visibleElements.length && tasksLeft != 0);

            if (tasksLeft == 0) {
                $(document).trigger('DAPI.queueEmpty');

                $("#layoutArea .layoutElement:not(.SBLinkLayoutElement) .SBLink").each(function() {
                    Storyboard.GuiEvents.setSBLink(this);
                });
            }
        },

        fixDate: function (date) {
            if (typeof date === 'string')
                return new Date(parseInt(date.match(/\d+/)[0], 10));

            return date;
        },

        strToDate: function (str) {
            if (str) {
                var arr = str.split(",");
                return new Date(arr[0], arr[1], arr[2]);
            }
            return "";
        },

        getFloatingTimePeriod: function (startDate, stopDate, projStartDate, projStopDate, period, periodSpan, periodSpanAmount) {
            if (period != 0) { // select start and stop date - no changes needed
                stopDate = projStopDate;
                switch (parseInt(period, 10)) {
                    case 20: // full period
                        startDate = projStartDate;
                        break;

                    case 18: // year to date
                        startDate = new Date(stopDate.getFullYear(), 0, 1);
                        break;

                    case 27: // select last...
                        startDate = new Date(stopDate.getTime());
                        for (var i = 0; i < periodSpanAmount && startDate.getTime() > projStartDate.getTime() ; i++)
                            switch (periodSpan) {
                                case "1": // days
                                    startDate.setDate(startDate.getDate() - 1);
                                    break;
                                case "2": // weeks
                                    if (i == 0) // last week, set monday
                                        while (startDate.getDay() != 0)
                                            startDate.setDate(startDate.getDate() - 1);
                                    else // after just remove a week
                                        startDate.setDate(startDate.getDate() - 7);
                                    break;
                                case "3": // months
                                    if (i == 0) // last month, set first day
                                        startDate.setDate(1);
                                    else // after just remove a month
                                        startDate.setMonth(startDate.getMonth() - 1);
                                    break;
                                case "4": //quarter
                                    if (i == 0) {
                                        var quarter = Math.floor((startDate.getMonth() + 3) / 3);
                                        startDate.setMonth((quarter - 1) * 3, 1);
                                    } else
                                        startDate.setMonth(startDate.getMonth() - 3);
                                    break;
                                case "6": // year
                                    if (i == 0) // last year, set first jan
                                        startDate.setMonth(0, 1);
                                    else
                                        startDate.setYear(startDate.getFullYear() - 1);
                                    break;
                            }
                        break;
                }
            }

            return { startDate: startDate, stopDate: stopDate };
        },

        getIntervalsNo: function (startDate, stopDate, timeInterval) {
            var intervalTypes = Storyboard.Constants.IntervalTypes;
            var timeDiff = Math.abs(stopDate.getTime() - startDate.getTime());

            switch (parseInt(timeInterval, 10)) {
                case intervalTypes.DAY:
                    return Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;

                case intervalTypes.WEEK:
                    return Math.ceil(timeDiff / (1000 * 3600 * 24 * 7));

                case intervalTypes.MONTH: // months
                    var months = (stopDate.getFullYear() - startDate.getFullYear()) * 12;
                    months += stopDate.getMonth() + 1;
                    months -= startDate.getMonth();
                    return months;

                case intervalTypes.QUARTER: // quarters
                case intervalTypes.HALF_YEAR: // half year
                    var span = timeInterval == 4 ? 3 : 6;
                    var qNo = Math.floor((stopDate.getMonth() + span) / span);
                    var start = new Date(stopDate.getTime());
                    start.setMonth((qNo - 1) * span, 1);

                    var ints = 1;
                    while (start.getTime() > startDate.getTime()) {
                        start.setMonth(start.getMonth() - span);
                        ints++;
                    }
                    return ints;

                case intervalTypes.YEAR: // year
                    return 1 + stopDate.getFullYear() - startDate.getFullYear();
            }

            return 1;
        },

        formatDate: function (date) {
            return $.datepicker.formatDate("yy-mm-dd", date);
        },

        parseDate: function (strDate) {
            return $.datepicker.parseDate("yy-mm-dd", strDate);
        },

        supportsPdf: function () {
            if (typeof window === "undefined" || typeof navigator === "undefined") { return false; }

            var createAXO = function (type) {
                var ax;
                try {
                    ax = new ActiveXObject(type);
                } catch (e) {
                    ax = null; //ensure ax remains null
                }
                return ax;
            };

            var supportsPdfMimeType = (typeof navigator.mimeTypes["application/pdf"] !== "undefined");
            var isIE = !!(window.ActiveXObject || "ActiveXObject" in window);
            var supportsPdfActiveX = !!(createAXO("AcroPDF.PDF") || createAXO("PDF.PdfCtrl"));
            var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
            return (isFirefox || supportsPdfMimeType || (isIE && supportsPdfActiveX));
        },

        animationEnd: function() {
           var a, el = document.createElement("element");

            var animations = {
                "animation"      : "animationend",
                "OAnimation"     : "oAnimationEnd",
                "MozAnimation"   : "animationend",
                "WebkitAnimation": "webkitAnimationEnd"
            }

            for (a in animations){
                if (el.style[a] !== undefined){
                    return animations[a];
                }
            }

            return false;
        },

        bytesToReadableSize: function (bytes) {
            var sizes = ["B", "KB", "MB", "GB", "TB"];
            if (bytes == 0) return "n/a";
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
        },

        convertFromHexToDecimal: function (hexvalue) {
            /* assuming #xxxxxx */
            if (!hexvalue || hexvalue.length !== 7)
                return 0;

            var r = parseInt(hexvalue.substring(1, 3), 16) * 65536;
            var g = parseInt(hexvalue.substring(3, 5), 16) * 256;
            var b = parseInt(hexvalue.substring(5, 7), 16);
            return r + g + b;
        },

        convertFromDecimalToHex: function (decimalvalue) {
            var r = Math.floor(decimalvalue / 65536);
            decimalvalue = decimalvalue - (r * 65536);
            var g = Math.floor(decimalvalue / 256);
            decimalvalue = decimalvalue - (g * 256);
            var b = decimalvalue;

            var padStr = padString;

            return '#' + padStr(r.toString(16), 2) + padStr(g.toString(16), 2) + padStr(b.toString(16), 2);
        },
    };
} ();

$.extend(Helpers, function () {
    var maxConcurrentRequests = 5; // maximum active requests to server (one slide = one request)
    var storytellerMaxConcurrencyLevel = 20; // mximum threads storyteller can use when generating objects
    var activeRequests = 0, activeRequestsObjects = 0;
    var queueLength;
 
    var requestCounter = 0;
    var queues = [];
    var taskKeys = {};

    for (var i = 1; i <= 3; i++)
        queues[i] = [];

    function setStorytellerMaxConcurrencyLevel(level) {
        storytellerMaxConcurrencyLevel = level;
    }

    function enqueue(action) {
        /* see if an action with same key (but different prio) already has been queued, which should be
        rescheduled with the correct priority */
        var queuedAction = taskKeys[action.key];
        if (queuedAction && action.dontReprioritize || (queuedAction && queuedAction.prio == action.prio)) {
            //in queue. skip.
        }
        else {
            if (queuedAction && queuedAction.prio !== action.prio) {
                //alter prio
                action.rc = queuedAction.rc;
                for (var i = 0; i < queues[queuedAction.prio].length; i++) {
                    if (queues[queuedAction.prio][i].key === queuedAction.key)
                        queues[queuedAction.prio].splice(i, 1);
                }
            }


            /* action.rc has a special meaning. even though action.key is used to identify a task
            it's also essential that the .rc at time of completion matches the .rc it had when it was scheduled.
            Otherwise the result will be discarded */
            action.rc = action.rc || ++requestCounter;

            //queue
            taskKeys[action.key] = action;
            queues[action.prio].push(action);
        }

        popAction();
    }

    function popAction() {
        var action;
        // have at least 2 active requests so that we won't have to wait whle one slide is processe to send a request for the next one
        // check number of elements on slides too, server can only work with storytellerMaxConcurrencyLevel number of elements at once
        if (activeRequests < 2 || (activeRequestsObjects < storytellerMaxConcurrencyLevel && activeRequests < maxConcurrentRequests)) {
            action = queues[1].shift() || queues[2].shift() || queues[3].shift();

            if (action) {
                activeRequests++;
                activeRequestsObjects += action.objectsCount;
                startAction(action);
            }
        }
    }

    function reportProgress() {
        /* we count active requests as half-complete, otherwise a batch with 4 requests
        would be reported as 100% from the start since they are popped of the queues */
        var tasksLeft = activeRequests / 2;
        tasksLeft += queues[1].length + queues[2].length + queues[3].length;

        var progress = Math.round(100 - (tasksLeft / queueLength) * 100);

        /* make sure progress is between 0 and 100. rather lie than look like a fool */
        progress = Math.max(0, progress);
        progress = Math.min(100, progress);

        $("#reportprogressBar").width(Math.floor(progress * 2, 10));
        if (!Storyboard.LayoutDesigner.slideShowMode)
            $('.DUI-ST-NAVIGATOR').toggle(activeRequests != 0);
        $("#reportProgress").toggle(activeRequests != 0);

        if (activeRequests == 0){
            $(document).trigger('DAPI.queueEmpty');

            $("#layoutArea .layoutElement:not(.SBLinkLayoutElement) .SBLink").each(function() {
                Storyboard.GuiEvents.setSBLink(this);
            });
        }
    }

    function startAction(action) {
        reportProgress();

        Helpers.perfJSonCall({
            method: action.method,
            data: action.data,
            successCallback: function () {
                endAction(action);
                if (!!taskKeys[action.key] && taskKeys[action.key].rc === action.rc)
                    action.successCallback && action.successCallback.apply(this, arguments);
            },
            failCallback: function () {
                endAction(action);
                if (!!taskKeys[action.key] && taskKeys[action.key].rc === action.rc)
                    action.failCallback && action.failCallback.apply(this, arguments);
            },
            message: action.message
        });
    }

    function endAction(action) {
        activeRequests--;
        activeRequestsObjects -= action.objectsCount;
        //var le = Storyboard.LayoutDesigner.getLayoutElementByGuid(action.key);
        //le.GUILoaded = true;

        reportProgress();
        popAction();
    }

    function performJSonCallThrottled(params) {

        var action = {
            method: params.method,
            data: params.data,
            successCallback: params.successCallback,
            failCallback: params.failCallback,
            message: params.message,
            prio: params.priority,
            key: params.key,
            dontReprioritize: params.dontReprioritize,
            objectsCount: params.data.layoutElements.length
        };
        enqueue(action);
    }

    function clearThrottleQueue(optionalGuid) {
        if (optionalGuid) {
            taskKeys[optionalGuid] = null;
        } else {
            taskKeys = {};
            queues[1] = [];
            queues[2] = [];
            queues[3] = [];
        }
    }

    function setThrottleQueueLength(len) {
        queueLength = len;
        $("#reportProgress").show();
        $("#reportprogressBar").width(0);
    }

    return {
        ThrottleQueue: {
            performJSonCallThrottled: performJSonCallThrottled,
            setThrottleQueueLength: setThrottleQueueLength,
            clearThrottleQueue: clearThrottleQueue,
            reportProgress: reportProgress,
            setStorytellerMaxConcurrencyLevel: setStorytellerMaxConcurrencyLevel
        }
    }

} ());

window.addEventListener('beforeunload', function() {
    if (typeof Storyboard !== 'undefined' && Storyboard.LayoutDesigner && !Storyboard.LayoutDesigner.isUnsaved) {
        Helpers.isUnloading = true;
    }
});

/* fastdom https://github.com/wilsonpage/fastdom */
// eslint-disable-next-line
!function(t){"use strict";function e(){var e=this;e.reads=[],e.writes=[],e.raf=u.bind(t)}function n(t){t.scheduled||(t.scheduled=!0,t.raf(i.bind(null,t)))}function i(t){var e,i=t.writes,o=t.reads;try{o.length,r(o),i.length,r(i)}catch(t){e=t}if(t.scheduled=!1,(o.length||i.length)&&n(t),e){if(e.message,!t.catch)throw e;t.catch(e)}}function r(t){for(var e;e=t.shift();)e()}function o(t,e){var n=t.indexOf(e);return!!~n&&!!t.splice(n,1)}function s(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])}var u=t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.msRequestAnimationFrame||function(t){return setTimeout(t,16)};e.prototype={constructor:e,measure:function(t,e){var i=e?t.bind(e):t;return this.reads.push(i),n(this),i},mutate:function(t,e){var i=e?t.bind(e):t;return this.writes.push(i),n(this),i},clear:function(t){return o(this.reads,t)||o(this.writes,t)},extend:function(t){if("object"!=typeof t)throw new Error("expected object");var e=Object.create(this);return s(e,t),e.fastdom=this,e.initialize&&e.initialize(),e},catch:null};var exports=t.fastdom=t.fastdom||new e;"function"==typeof define?define(function(){return exports}):"object"==typeof module&&(module.exports=exports)}("undefined"!=typeof window?window:this);
/* end fastdom */

/* Throttling and Debouncing */
$.extend(Helpers, function () {

    //  Underscore.js 1.8.3
    //  http://underscorejs.org
    //  (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    //  Underscore may be freely distributed under the MIT license.

    var now = Date.now || function () {
        return new Date().getTime();
    };

    var debounce = function (func, wait, immediate) {
        var timeout, args, context, timestamp, result;

        var later = function () {
            var last = now() - timestamp;

            if (last < wait && last >= 0) {
                timeout = setTimeout(later, wait - last);
            } else {
                timeout = null;
                if (!immediate) {
                    result = func.apply(context, args);
                    if (!timeout) context = args = null;
                }
            }
        };

        return function () {
            context = this;
            args = arguments;
            timestamp = now();
            var callNow = immediate && !timeout;
            if (!timeout) timeout = setTimeout(later, wait);
            if (callNow) {
                result = func.apply(context, args);
                context = args = null;
            }

            return result;
        };
    };

    var throttle = function (func, wait, options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        if (!options) options = {};
        var later = function () {
            previous = options.leading === false ? 0 : now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        };
        return function () {
            var time = now();
            if (!previous && options.leading === false) previous = time;
            var remaining = wait - (time - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = time;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    };

    return {
        debounce: debounce,
        throttle: throttle
    };
}());

/* Extend jQuery UI datepicker - add option "afterShow" function -  It is called just before the datepicker is displayed. */
$(function() {
    if($.datepicker && !$.datepicker._updateDatepicker_original){
        $.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
        $.datepicker._updateDatepicker = function(inst) {
        $.datepicker._updateDatepicker_original(inst);
        var afterShow = this._get(inst, 'afterShow');
        if (afterShow)
            afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
        }
    }
});

// The caching module allows storing and retrieving data based on URLs and parameters 
// to avoid redundant server requests and improve performance
window.clientCache = (function() {
    var cache = new Map();

    function generateKey({ url, params }) {
        return url + '|' + JSON.stringify(params);
    }
  
    function getData({ url, params }) {
        const cacheKey = generateKey({ url, params });
        const cacheValue = cache.get(cacheKey);

        if (cacheValue) {
            clearTimeout(cacheValue.timeout);
            cacheValue.timeout = setTimeout(() => deleteData({ url, params }), cacheValue.keepUnusedDataFor * 1000);

            return cacheValue.data;
        }
        
        return null;
    }

    function hasData({ url, params }) {
        const cacheKey = generateKey({ url, params });
        return cache.has(cacheKey);
    }
  
    function setData({ url, params, data, keepUnusedDataFor }) {
        const cacheKey = generateKey({ url, params });
        const validKeepUnusedDataFor = Math.max(0, Math.min(keepUnusedDataFor, 1800)); // 30 minutes max

        const timeout = setTimeout(() => deleteData({ url, params }), validKeepUnusedDataFor * 1000);

        cache.set(cacheKey, {
            url,
            params,
            data,
            keepUnusedDataFor: validKeepUnusedDataFor,
            timeout
        });
    }

    function deleteData({ url, params, method }) {
        if (url && params) {
            const cacheKey = generateKey({ url, params });
            const cacheValue = cache.get(cacheKey);

            if (cacheValue) {
                clearTimeout(cacheValue.timeout);
                cache.delete(cacheKey);
            }
        } else {
            for (const [cacheKey, cacheValue] of cache.entries()) {
                if ((url && cacheKey.startsWith(url)) ||
                    (method && cacheKey.includes(method))) {
                        clearTimeout(cacheValue.timeout);
                        cache.delete(cacheKey);
                    }
            }
        }
    }

    function clear() {
        for (const [cacheKey, cacheValue] of cache.entries()) {
            if (cacheValue.timeout) clearTimeout(cacheValue.timeout);
            cache.delete(cacheKey);
        }
        cache = new Map();
    }

    function _getCache() {
        return cache;
    }

    return {
        _getCache,
        generateKey,
        getData,
        hasData,
        setData,
        deleteData,
        clear,
    }
})();